import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="enable-button"
export default class extends Controller {
  static targets = ["button"]
  static values = {addClasses: Array, removeClasses: Array}

  enable() {
    this.buttonTarget.removeAttribute("disabled")
    this.buttonTarget.classList.toggle("disabled", false)
    if (this.hasAddClassesValue) {
      Array.from(this.addClassesValue).forEach(className => {
        this.buttonTarget.classList.toggle(className, true)
      })
    }
    if (this.hasRemoveClassesValue) {
      Array.from(this.removeClassesValue).forEach(className => {
        this.buttonTarget.classList.toggle(className, false)
      })
    }
  }
}
